/**
 * Created by staffanrantzow on 14/10/16.
 */

import axios from 'axios';
import InfoEntity from './info-entity';
import PendingRequestEntity from '../entities/pending-request-entity';

import * as variables from 'frilans-finans/variables';

class InfoService {

  hydrate (list) {
    return list.map(data => new InfoEntity(
      data.id,
      data.date,
      data.title.rendered,
      data.content.rendered
    ));
  }

  get () {
    let pendingRequest = new PendingRequestEntity();
    pendingRequest.promise = axios.get(
      `${variables.frontUrl}/wp-json/wp/v2/viktig-information?filter[order]=DESC&per_page=2`,
      {
        cancelToken: new axios.CancelToken(function executor (c) {
          pendingRequest.cancel = c;
        })
      })
      .then((response) => {
        if (response.data && response.data.length > 0) {
          return this.hydrate(response.data);
        }
        return [];
      });
    return pendingRequest;
  }

}

export default new InfoService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/info/info-service.js
 **/